import { regressionTest } from "../../../../test-utils/regression";

describe("ux-comparison-table with data", async () => {
    it("passes the regression test", async () => {
        await regressionTest({
            storyId:
                "content-tables-comparison-table--comparison-table-data-fed",
            componentTag: "ux-comparison-table",
            pageHeight: 450,
            pageWidth: 400,
            performActions: async (page) => {
                await page.waitForSelector(".ux-comparison-table.hydrated");
                await page.waitForSelector(
                    "ux-comparison-table th:nth-child(2)",
                    { visible: true }
                );
                await page.waitForTimeout(1000);
            },
        });
    });
});

describe("ux-comparison-table with text", async () => {
    it("passes the regression test", async () => {
        await regressionTest({
            storyId:
                "content-tables-comparison-table--comparison-table-text-content",
            componentTag: "ux-comparison-table",
            pageHeight: 450,
            pageWidth: 400,
            performActions: async (page) => {
                await page.waitForSelector(".ux-comparison-table.hydrated");
            },
        });
    });
});
